import {
  canonicalizeToPolyllm,
  getPolyllmTranslationLocale,
} from '~/projects/polyllm-chat/i18n/localePath';

export type LanguageFieldOption = {
  /** Значення = i18n lng / platform_lang (translation-locale код). */
  value: string;
  /** Англомовний лейбл — fallback, коли Intl.DisplayNames недоступний. */
  fallbackLabel: string;
};

export const LANGUAGE_FIELD_OPTIONS: ReadonlyArray<LanguageFieldOption> = [
  { value: 'en', fallbackLabel: 'English' },
  { value: 'zh-Hans-CN', fallbackLabel: 'Chinese' },
  { value: 'hi', fallbackLabel: 'Hindi' },
  { value: 'es-419', fallbackLabel: 'Spanish' },
  { value: 'fr', fallbackLabel: 'French' },
  { value: 'ms', fallbackLabel: 'Malay' },
  { value: 'bn', fallbackLabel: 'Bengali' },
  { value: 'pt-BR', fallbackLabel: 'Portuguese' },
  { value: 'id', fallbackLabel: 'Indonesian' },
  { value: 'de', fallbackLabel: 'German' },
  { value: 'ja', fallbackLabel: 'Japanese' },
  { value: 'mr', fallbackLabel: 'Marathi' },
  { value: 'te', fallbackLabel: 'Telugu' },
  { value: 'tr', fallbackLabel: 'Turkish' },
  { value: 'ta', fallbackLabel: 'Tamil' },
  { value: 'vi', fallbackLabel: 'Vietnamese' },
  { value: 'ko', fallbackLabel: 'Korean' },
  { value: 'it', fallbackLabel: 'Italian' },
  { value: 'th', fallbackLabel: 'Thai' },
  { value: 'gu', fallbackLabel: 'Gujarati' },
  { value: 'kn', fallbackLabel: 'Kannada' },
  { value: 'pl', fallbackLabel: 'Polish' },
  { value: 'ml', fallbackLabel: 'Malayalam' },
  { value: 'ro', fallbackLabel: 'Romanian' },
  { value: 'nl', fallbackLabel: 'Dutch' },
  { value: 'tl', fallbackLabel: 'Filipino' },
  { value: 'uk', fallbackLabel: 'Ukrainian' },
  { value: 'sr', fallbackLabel: 'Serbian' },
  { value: 'cs', fallbackLabel: 'Czech' },
  { value: 'el', fallbackLabel: 'Greek' },
  { value: 'sv', fallbackLabel: 'Swedish' },
  { value: 'hu', fallbackLabel: 'Hungarian' },
  { value: 'da', fallbackLabel: 'Danish' },
  { value: 'fi', fallbackLabel: 'Finnish' },
  { value: 'no', fallbackLabel: 'Norwegian' },
  { value: 'bg', fallbackLabel: 'Bulgarian' },
  { value: 'sk', fallbackLabel: 'Slovak' },
  { value: 'lt', fallbackLabel: 'Lithuanian' },
  { value: 'lv', fallbackLabel: 'Latvian' },
  { value: 'et', fallbackLabel: 'Estonian' },
  { value: 'hr', fallbackLabel: 'Croatian' },
  { value: 'ca', fallbackLabel: 'Catalan' },
  { value: 'sl', fallbackLabel: 'Slovenian' },
];

/**
 * Рідна назва мови (autonym) через вбудований Intl.DisplayNames.
 * База береться з первинного субтегу (es-419 → es, zh-Hans-CN → zh).
 * Fallback на англомовний лейбл, якщо API недоступне або повертає сам код.
 */
export const getNativeLanguageName = (
  value: string,
  fallbackLabel: string,
): string => {
  const base = value.split('-')[0];

  try {
    const native = new Intl.DisplayNames([base], { type: 'language' }).of(base);

    return native && native !== base ? native : fallbackLabel;
  } catch {
    return fallbackLabel;
  }
};

/**
 * Нормалізує збережений profile.platform_lang (або i18n.language) у значення
 * опції селекта. Абсорбує розбіжність кодів між sidebar (fil/nb) і polyllm (tl/no).
 */
export const resolveLanguageFieldValue = (language?: string): string => {
  if (!language || language === 'en') {
    return 'en';
  }

  const polyllmLocale = canonicalizeToPolyllm(language);

  return polyllmLocale ? getPolyllmTranslationLocale(polyllmLocale) : 'en';
};
